export default "__VITE_PUBLIC_ASSET__4c505caa__"